export default class Map {
  constructor(options) {
    // intialise Google Map
    function initialize() {
      var myLatlng = new google.maps.LatLng(-37.863310, 145.028390),
      mapOptions = {
        zoom: 17,
        center: myLatlng,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        // styles: [
        //   {
        //     "featureType": "all",
        //     "elementType": "labels.text.fill",
        //     "stylers": [
        //       {
        //         "saturation": 36
        //       },
        //       {
        //         "color": "#333333"
        //       },
        //       {
        //         "lightness": 40
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "all",
        //     "elementType": "labels.text.stroke",
        //     "stylers": [
        //       {
        //         "visibility": "on"
        //       },
        //       {
        //         "color": "#ffffff"
        //       },
        //       {
        //         "lightness": 16
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "all",
        //     "elementType": "labels.icon",
        //     "stylers": [
        //       {
        //         "visibility": "off"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "administrative",
        //     "elementType": "all",
        //     "stylers": [
        //       {
        //         "visibility": "simplified"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "administrative",
        //     "elementType": "geometry.fill",
        //     "stylers": [
        //       {
        //         "color": "#fefefe"
        //       },
        //       {
        //         "lightness": 20
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "administrative",
        //     "elementType": "geometry.stroke",
        //     "stylers": [
        //       {
        //         "color": "#fefefe"
        //       },
        //       {
        //         "lightness": 17
        //       },
        //       {
        //         "weight": 1.2
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "landscape",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#ecdfdd"
        //       },
        //       {
        //         "lightness": 20
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "poi",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#f5f5f5"
        //       },
        //       {
        //         "lightness": 21
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "poi.park",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#dedede"
        //       },
        //       {
        //         "lightness": 21
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "poi.park",
        //     "elementType": "geometry.fill",
        //     "stylers": [
        //       {
        //         "color": "#c1c1cc"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.highway",
        //     "elementType": "all",
        //     "stylers": [
        //       {
        //         "visibility": "on"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.highway",
        //     "elementType": "geometry.fill",
        //     "stylers": [
        //       {
        //         "color": "#b3b7c6"
        //       },
        //       {
        //         "lightness": 17
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.highway",
        //     "elementType": "geometry.stroke",
        //     "stylers": [
        //       {
        //         "lightness": 29
        //       },
        //       {
        //         "weight": 0.2
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.highway",
        //     "elementType": "labels.text.fill",
        //     "stylers": [
        //       {
        //         "color": "#1f4a88"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.arterial",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#ffffff"
        //       },
        //       {
        //         "lightness": 18
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.arterial",
        //     "elementType": "geometry.fill",
        //     "stylers": [
        //       {
        //         "color": "#ffede5"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.arterial",
        //     "elementType": "labels.text.fill",
        //     "stylers": [
        //       {
        //         "color": "#1f4b89"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.local",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#ffffff"
        //       },
        //       {
        //         "lightness": 16
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.local",
        //     "elementType": "geometry.fill",
        //     "stylers": [
        //       {
        //         "color": "#ffede5"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.local",
        //     "elementType": "labels.text.fill",
        //     "stylers": [
        //       {
        //         "color": "#afb5c4"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "road.local",
        //     "elementType": "labels.text.stroke",
        //     "stylers": [
        //       {
        //         "color": "#ffede5"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "transit",
        //     "elementType": "all",
        //     "stylers": [
        //       {
        //         "visibility": "off"
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "transit",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#f2f2f2"
        //       },
        //       {
        //         "lightness": 19
        //       }
        //     ]
        //   },
        //   {
        //     "featureType": "water",
        //     "elementType": "geometry",
        //     "stylers": [
        //       {
        //         "color": "#e9e9e9"
        //       },
        //       {
        //         "lightness": 17
        //       }
        //     ]
        //   }
        // ]
      }

      var map = new google.maps.Map(document.getElementById('map'), mapOptions)

      var sizeX = 75;
      var sizeY = 91;

      var icon = {
        url: templateDir + '/assets/src/images/map-pin-v2.svg',
        size: new google.maps.Size(sizeX, sizeY),
        origin: new google.maps.Point(0, 0),
      };

      var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        icon: icon
      })

      google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter()
        google.maps.event.trigger(map, "resize")
        map.setCenter(center)
      })
    }

    google.maps.event.addDomListener(window, 'load', initialize)
  }
}
